import { Component } from '@angular/core';
import { DashboardAssistantCardSkeleton } from '../dashboard-assistant-card-skeleton/dashboard-assistant-card-skeleton';
import { DashboardSummaryCardSkeleton } from '../dashboard-summary-card-skeleton/dashboard-summary-card-skeleton';
import { DashboardListCardSkeleton } from '../dashboard-list-card-skeleton/dashboard-list-card-skeleton';
import { Skeleton } from 'excellence-ui';
import { DashboardHpfcSkeleton } from '../dashboard-hpfc-skeleton/dashboard-hpfc-skeleton';
import { DashboardConsultantCardSkeleton } from '../dashboard-consultant-card-skeleton/dashboard-consultant-card-skeleton';
import { DashboardHelpCenterCardSkeleton } from '../dashboard-help-center-card-skeleton/dashboard-help-center-card-skeleton';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';

@Component({
  selector: 'app-dashboard-skeleton',
  imports: [
    DashboardAssistantCardSkeleton,
    DashboardSummaryCardSkeleton,
    DashboardListCardSkeleton,
    Skeleton,
    DashboardHpfcSkeleton,
    DashboardConsultantCardSkeleton,
    DashboardHelpCenterCardSkeleton,
    FeatureEnabledDirective,
  ],
  templateUrl: './dashboard-skeleton.html',
})
export class DashboardSkeleton {}
